import { App, type ModalFuncProps } from 'antd';
import { IconUtils, type IconType } from '@/utils';

interface ExtendedModalFuncProps extends ModalFuncProps {
  type?: IconType;
}

export default function useAppModal() {
  const { modal } = App.useApp();

  const withIcon = (config: ExtendedModalFuncProps): ModalFuncProps => {
    const { type = 'info', ...rest } = config;
    return {
      ...rest,
      icon: IconUtils.getIcon(type, true),
    };
  };

  return {
    confirm: (config: ExtendedModalFuncProps) =>
      modal.confirm(withIcon({ type: 'confirm', focusable: { autoFocusButton: 'cancel' }, ...config })),
    info: (config: ExtendedModalFuncProps) => modal.info(withIcon({ type: 'info',focusable: { autoFocusButton: 'cancel' }, ...config })),
    error: (config: ExtendedModalFuncProps) => modal.error(withIcon({ type: 'error',focusable: { autoFocusButton: 'cancel' }, ...config })),
    warning: (config: ExtendedModalFuncProps) =>
      modal.warning(withIcon({ type: 'warning',focusable: { autoFocusButton: 'cancel' }, ...config })),
  };
}
